<template>
  <div>
    <Menu></Menu>
    <div class="router-view">
      <router-view></router-view>
    </div>
    <Info/>
  </div>
</template>

<script>

import Menu from './Menu.vue';
import  { store } from './store';
import lang from './lang';
import Info from './components/Info.vue';

export default {
  name: 'App',
  components: {
    Menu,
    Info
  },
  provide: {
	lang: code => {
		const l = window.localStorage.getItem('user_lang');
		store.lang = l ? l : 'en';
		return lang[store.lang][code];
	},
  }
}
</script>
